export const fetchProfile = () => {
  return {
    method: 'GET',
    url: '/profile?buster=' + new Date().toISOString()
  };
};

export const updateProfile = (data) => {
  return {
    method: 'PUT',
    url: '/profile',
    data
  };
};

export const setupIntegration = (id, data) => ({
  method: 'POST',
  url: `/profile/integrations/setup/${id}`,
  data
})

export const disableIntegration = (id) => {
  return {
    method: 'POST',
    url: `/profile/integrations/deactivate/${id}`
  };
};

export const pusherAuth = (data) => ({
  method: 'POST',
  url: '/auth',
  data
})